import { addDays, format, isWeekend, parseISO, startOfDay } from 'date-fns';
import { BusinessDateTime } from 'utils/toBusinessDateTime';

export const WEEK_DAYS_COUNT = 5;

export const isActive = (date: Date) => {
  const now = new Date();
  const startNowDate = startOfDay(now);
  return startNowDate <= date;
};

/** Today while its deadline has not passed, otherwise the next weekday. */
export const getNearestOrderDay = (now: BusinessDateTime, deadline: string) => {
  const today = parseISO(now.date);
  let day =
    isWeekend(today) || now.time >= deadline ? addDays(today, 1) : today;

  while (isWeekend(day)) {
    day = addDays(day, 1);
  }

  return format(day, 'yyyy-MM-dd');
};
